import { StepT } from "../../Step/types";

import { GroupStep } from "./GroupStep";
import { GroupTitle } from "./GroupTitile";

interface GroupSectionProps {
  group: string;
  groupIndex: number;
  stepsInGroup: (StepT & { originalIndex: number })[];
  activeStep: number;
}

export const GroupSection = ({
  group,
  groupIndex,
  stepsInGroup,
  activeStep,
}: GroupSectionProps) => {
  const isGroupCompleted = stepsInGroup.every(step => activeStep > step.originalIndex);
  const activeGroupIndex = stepsInGroup.find(step => step.originalIndex === activeStep);
  const isActiveGroup = activeGroupIndex?.group === group;

  return (
    <div className="flex flex-col">
      <GroupTitle
        group={group}
        groupIndex={groupIndex}
        isGroupCompleted={isGroupCompleted}
        isActiveGroup={isActiveGroup}
      />
      <div className="flex flex-col gap-2">
        {stepsInGroup.map((step, stepIndex) => {
          const isCompleted = activeStep > step.originalIndex;
          const isCurrent = activeStep === step.originalIndex;

          return (
            <GroupStep
              key={step.id}
              step={step}
              groupIndex={groupIndex}
              stepIndex={stepIndex}
              isCompleted={isCompleted}
              isCurrent={isCurrent}
            />
          );
        })}
      </div>
    </div>
  );
};
